/**
 * Swiss rounding utility
 * Rounds amounts to the nearest 0.05 CHF as per Swiss currency standards
 */

/**
 * Round a number to the nearest 0.05 (Swiss franc rounding)
 * @param {number} amount - The amount to round
 * @returns {number} - The rounded amount
 */
export function swissRound(amount) {
  return Math.round(amount * 20) / 20;
}

/**
 * Format a number as Swiss francs with proper rounding
 * @param {number} amount - The amount to format
 * @returns {string} - The formatted amount (e.g., "123.45")
 */
export function formatSwissFrancs(amount) {
  const rounded = swissRound(amount);
  return rounded.toFixed(2);
}
